const initialState = {
  loading: false,
  error: false,
  totalSuspisious: 0,
  suspisiousListing: [],
  suspisiousDetail: null,
};

const suspisiousReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_SUSPISIOUS_REQUEST":
    case "DELETE_SUSPISIOUS_REQUEST":
      return {
        ...state,
        loading: true,
      };

    case "GET_SUSPISIOUS_REQUEST_SUCCESS":
      return {
        ...state,
        loading: false,
        suspisiousListing: action.payload,
        totalSuspisious: action.total,
        error: false,
      };

    case "GET_SUSPISIOUS_REQUEST_FAILED":
    case "DELETE_SUSPISIOUS_FAILED":
      return {
        ...state,
        loading: false,
        error: true,
      };

    case "DELETE_SUSPISIOUS_SUCCESS":
      return {
        ...state,
        loading: false,
        error: false,
      };

    default:
      return state;
  }
};

export default suspisiousReducer;
